<div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div class="dashboard-filter w-full">
    <div class="row flex flex-row justify-center items-center xs:px-[5rem] sm:px-[5rem] md:px-[10rem] lg:px-[18.3rem]">
      <div class="label flex flex-row">
        Dashboard <span class="required-mark">*</span>
      </div>
      <app-dropdown
        class="input dashboard-input w-full xs:min-w-full sm:min-w-full md:min-w-0"
        [parentFormGroup]="form"
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['dashboard']"
        [options]="dashboardFilterList"
        controlName="dashboard"
        placeholder="Select one"
        type="small"
      />
    </div>
  </div>
  <div class="filter-section w-full">
    <ng-template
      filterHost
    ></ng-template>
  </div>
  <div
    class="table-section"
  >
    <mat-expansion-panel
      class="mat-elevation-z0 expansion-panel w-full"
      [expanded]="expandPanel"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          {{heading}} Dashboard
        </div>

        <app-primary-button
          class="xs:w-[15rem] sm:w-[15rem] md:w-[13rem]"
          *ngIf="selectedDashboard === 1 && !isDrilldown"
          type="small"
          (handleClick)="onAddGroup()"
        >
          Add Group
        </app-primary-button>
      </mat-expansion-panel-header>
      <div
        class="no-data flex justify-center items-center"
        *ngIf="!expandPanel; else tableData"
      >
        No Dashboard Selected!
      </div>
      <ng-template
        #tableData
        tableHost
      ></ng-template>
    </mat-expansion-panel>
  </div>
</div>
